import apiClient from "../../../service/apiClient";
import { buildZipDownloadUrl } from "../../../shared/utils/downloadZip";
import {
  ASSET_STATEMENT_ENDPOINTS,
} from "../../../app/apiEndpoints";

export const getInvestorsByContact = (contactId) =>
  apiClient.get(ASSET_STATEMENT_ENDPOINTS.GET_INVESTOR_BY_CONTACT, {
    params: { contactId, addSelect: true, isAsset: false },
  });

export const getEntitiesByInvestor = (investorId, contactId) =>
  apiClient.get(ASSET_STATEMENT_ENDPOINTS.GET_ENTITIES_BY_INVESTOR, {
    params: { investorId, contactId, documentGroup: 1, addSelect: true },
  });

export const getStatementsByFilters = (payload) =>
  apiClient.get(ASSET_STATEMENT_ENDPOINTS.GET_DOCUMENTS_BY_ENTITY, {
    params: payload,
  });


// single-doc download
export const downloadDocumentBlob = (
  documentId,
  isRejected = false,
  userId = 0,
  appRoleId = 1
) =>
  apiClient.get(ASSET_STATEMENT_ENDPOINTS.GET_DOCUMENT_BY_DOCUMENT_ID, {
    params: { documentId, isRejected, userId, appRoleId },
    responseType: "blob",
  });

export const getDocumentNameById = (documentId, isRejected = false) =>
  apiClient.get(
    `${ASSET_STATEMENT_ENDPOINTS.GET_DOCUMENT_NAME_BY_DOCUMENT_ID}/${documentId},${isRejected}`
  );


// blob utils
export const openBlobInNewTab = (blob) => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
};


// MVC download URLs

export const getClientDocumentDownloadUrl = (params) =>
  `${ASSET_STATEMENT_ENDPOINTS.GET_CLIENT_DOCUMENT_DOWNLOAD}?${new URLSearchParams(
    params
  ).toString()}`;

export const getClientDocumentsDownloadUrl = (params) =>
  `${ASSET_STATEMENT_ENDPOINTS.GET_CLIENT_DOCUMENTS_DOWNLOAD}?${new URLSearchParams(
    params
  ).toString()}`;

export const getClientDocumentsSinglePDFDownloadUrl = (params) =>
  `${ASSET_STATEMENT_ENDPOINTS.GET_CLIENT_DOCUMENTS_SINGLE_PDF_DOWNLOAD}?${new URLSearchParams(
    params
  ).toString()}`;


// customize

export const getStatementCustomize = (pageId, userId, name) =>
  apiClient.get(
    `${ASSET_STATEMENT_ENDPOINTS.GET_STATEMENT_CUSTOMIZE}/${pageId},${userId},${encodeURIComponent(
      name
    )}`
  );

export const saveStatementCustomize = (payload) =>
  apiClient.post(
    ASSET_STATEMENT_ENDPOINTS.SAVE_GRID_CUSTOMIZE_COLUMNS,
    payload
  );

export const getStatementEntityByInvestor = (InvestorId) =>
  apiClient.get(
    ASSET_STATEMENT_ENDPOINTS.GET_STATEMENT_ENTITY_BY_INVESTOR,
    { params: { InvestorId } }
  );


// zip download

export const downloadStatementZipBlob = ({
  documentIds,
  fileName = "Statements",
  userId = 0,
  appRoleId = 0,
  isRejected = false,
}) =>
  apiClient.get(
    ASSET_STATEMENT_ENDPOINTS.GET_STATEMENT_AS_SINGLE_ZIP_DOWNLOAD,
    {
      params: {
        documentIds: Array.isArray(documentIds)
          ? documentIds.join(",")
          : String(documentIds || ""),
        fileName,
        userId,
        appRoleId,
        isRejected,
      },
      responseType: "blob",
    }
  );